import PropTypes from 'prop-types'
import styled from 'styled-components'

const Label = styled.label`
  -webkit-tap-highlight-color: ${props => props.theme.colors.black};
  appearance: none;
  flex-grow: 1;
  user-select: none;
  font-family: ${props => props.theme.fonts.avenirNextDemi};
  font-size: 16px;
  color: ${props => props.theme.colors.text.formLabel};
  display: flex;
  flex-direction: ${props => props.direction};
  margin: 0;
  padding: 0;
  align-items: center;
`

Label.defaultProps = {
  direction: 'row'
}

Label.propTypes = {
  direction: PropTypes.oneOf([ 'row', 'column' ])
}

export default Label
